<db-benchmark-table
        [companyName]="companyName"
                    [websiteId]="websiteId" [demoUser]="demoUser" [hostedCounts]="hostedCounts" [benchmark]="benchmark" [loading]="loading" [isHosted]="isHosted"  [userSubscription]="userSubscription"
                    (onRerun)="rerunBenchmark()"
                    (onOptimize)="(userSubscription?.trialBoosterClient || userSubscription?.boosterProClient) ? buyNow() : migrate()"
></db-benchmark-table>

<div
  *ngIf="!loading && !isHosted && (benchmark?.serverPerformance > benchmarkMetrics.HIGH_SERVER_PERFORMANCE
    || benchmark?.wordpressPerformance > benchmarkMetrics.HIGH_WORDPRESS_PERFORMANCE
    || benchmark?.phpVersion < benchmarkMetrics.PHP_VERSION)"
  class="db-benchmark__diagnostics">
  <hr>
  <h3 class="mt25 mb20">Diagnostics</h3>

  <ds-accordion *ngIf="!benchmark?.serverPerformance || benchmark?.serverPerformance > benchmarkMetrics.HIGH_SERVER_PERFORMANCE"
                class="mb10" title="Server performance benchmark"
                [body]="benchmarkErrors.serverPerformance"></ds-accordion>

  <ds-accordion *ngIf="!benchmark?.wordpressPerformance || benchmark?.wordpressPerformance > benchmarkMetrics.HIGH_WORDPRESS_PERFORMANCE"
                class="mb10" title="WordPress performance benchmark"
                [body]="benchmarkErrors.wordPressPerformance"></ds-accordion>

  <ds-accordion *ngIf="benchmark?.phpVersion < benchmarkMetrics.PHP_VERSION"
                class="mb10" title="PHP version {{benchmark.phpVersion}} is outdated"
                [body]="benchmarkErrors.phpVersion"></ds-accordion>

<!--  <ds-accordion *ngIf="benchmark?.mysqlVersion < benchmarkMetrics.MYSQL_VERSION"-->
<!--                class="mb10" title="MySQL version {{benchmark.mysqlVersion}} is outdated"-->
<!--                [body]="benchmarkErrors.mysqlVersion"></ds-accordion>-->
</div>
